<div class="edit-details-container d-flex flex-column">
  <div class="d-flex justify-content-between align-items-center">
    <span class="edit-details-text">Edit details</span>
    <div class="img-container" mat-dialog-close>
      <img
        src="../../../assets/images/crossIconDarkTheme.svg"
        class="cross-icon"
      />
    </div>
  </div>

  <form (ngSubmit)="editDetails()" [formGroup]="editDetailsForm">
    <div class="d-flex flex-column">
      <label class="search-text">Serial no.</label>
      <div class="d-flex align-items-center position-relative mt-1">
        <input
          class="dp-input-control update-input w-100"
          placeholder="Enter Serial No"
          formControlName="serialNo"
          readonly
        />
        <img
        src="../../../assets/images/crossIconDarkTheme.svg"
        class="input-cross-icon position-absolute"
        (click)="clearSerialNo()"
      />
      </div>
    </div>


    <div class="d-flex flex-column edit-gap">
      <label class="search-text">Contact no.</label>
      <input
        class="dp-input-control update-input mt-1"
        placeholder="Enter Contact No"
        formControlName="contactNo"
        minlength="10"
                    maxlength="10"
      />
      <span
                  *ngIf="
                    editDetailsForm.controls['contactNo'].invalid &&
                    editDetailsForm.controls['contactNo'].touched
                  "
                  class="error-message mt-1"
                >
                  Please enter a valid contact no
                </span>
    </div>
    <div class="d-flex flex-column edit-gap">
      <label class="search-text">Address</label>
      <textarea
        class="dp-input-control fixed-height-textarea mt-1"
        placeholder="Enter Address"
        formControlName="address"
      ></textarea>
      <span
      *ngIf="
        editDetailsForm.controls['address'].invalid &&
        editDetailsForm.controls['address'].touched
      "
      class="error-message mt-1"
    >
      Please enter a valid address
    </span>
    </div>

    <button class="dp-primary-btn save-btn edit-gap">Save Changes</button>
  </form>
</div>
